export default "__VITE_ASSET__D$eg4nOq__"